import { useQuery } from '@tanstack/react-query';
import {
  type UseQueryReturnType,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { feeKeys } from './keys';

const savedCards = graphql(/* GraphQL */ `
  query fees_savedCards {
    fees_savedCards {
      id
      last4
      brand
      expiry
    }
  }
`);

const savedCardsQuery = () => ({
  queryKey: feeKeys.savedCards(),
  queryFn: () => gqlClient.request(savedCards),
});

export function getSavedCards() {
  return queryClient.fetchQuery(savedCardsQuery());
}

export function useSavedCards() {
  return useQuery({
    ...savedCardsQuery(),
    select: ({ fees_savedCards }) => fees_savedCards,
  });
}

export type ReturnTypeFromUseSavedCards = UseQueryReturnType<
  typeof useSavedCards
>[number];
